export * from "./Routes";
export * from "./Theme";
export * from "./ContextMenuItems";
export * from "./DrawerEventType";
export * from "./FileUpload";
export * from "./Authorization";
export * from "./UserGroups";
export * from "./EntityType";
export * from "./ConfirmationDialogTypes";
export * from "./DialogEvent";
export * from "./ConfirmationTypes";
export * from "./SnackbarSeverity";
export * from "./UIElement";
export const SIDEBAR_WIDTH = 260;
export const HEADER_HEIGHT = 49;
export * from "./InfoType";
export * from "./PromptType";
export * from "./DrawerTypes";
export * from "./DialogTypes";
export * from "./Filter";
export * from "./FileExtensions";
export * from "./FeatureFlags";

export const config = {
  defaultPath: "",
  i18n: "en",
  miniDrawer: false,
  container: true,
  mode: "light",
  presetColor: "default",
  themeDirection: "ltr",
};
